<template>
  <div style="padding-top: 10vh; text-align: center;">
    <div v-if="query.connect_result === 'connect_success'">
      <md-empty-state
        class="md-primary"
        md-rounded
        md-icon="done"
        :md-label="$t('Successful')"
      >
      </md-empty-state>

      <a href="#/dashboard">
        <md-button class="md-primary" style="margin-top: 40px;">{{
          $t("Go to Dashboard")
        }}</md-button>
      </a>
    </div>
    <md-empty-state
      v-else-if="query.connect_result === 'connect_fail'"
      class="md-accent"
      md-rounded
      md-icon="alarm_off"
      :md-label="$t('Failed')"
      :md-description="$t('An exception occurred, please try again later.')"
    >
    </md-empty-state>
    <md-empty-state
      v-else
      md-rounded
      md-icon="access_time"
      :md-label="$t('Processing')"
      :md-description="$t('Please wait while we process your request.')"
    >
    </md-empty-state>
    <Notifications />
  </div>
</template>

<script>
import { connectAccount } from "@/services/auth.service";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  name: "EmptyStateRounded",
  data() {
    return {
      query: this.$router.history.current.query || {}
    };
  },
  mounted() {
    EventBus.$on("getUserProfile", () => {
      if (this.query.key === "connect_account") {
        connectAccount()
          .then(({ data }) => {
            if (data.data) {
              window.location.href = data.data;
            }
          })
          .catch(err => {
            if (err.data.code === 1102) {
              let _self = this;
              swal
                .fire({
                  title: this.$t("Warning"),
                  text: this.$t("You already connected your account!"),
                  type: "warning",
                  confirmButtonClass: "md-button md-warning",
                  buttonsStyling: false,
                  confirmButtonText: this.$t("Go to Dashboard")
                })
                .then(({ value }) => {
                  if (value) {
                    _self.$router.replace("/dashboard");
                  }
                });
            }
          });
      }
    });
    EventBus.$on("failedGetUserProfile", () => {
      this.$router.push({
        path: "/login",
        query: { loginSuccessTargetPage: "/processing?key=connect_account" }
      });
    });
  }
};
</script>
